import React, { Component, Fragment } from 'react';
import { Router, Route, Switch, Redirect, NavLink } from 'react-router-dom';
import Login from '../components/Login';
import { connect } from 'react-redux';
import AppNavbar from '../components/displayComponents/AppNavbar';
import { Drawer, List, ListItem, Grid, ListItemText, LinearProgress, Typography, Card } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import EnquisaSatisfaccionContainer from '../components/Satisfations/Satisfation';
import createHistory from 'history/createBrowserHistory';
import '../App.css';
import * as mainActions from '../actions/mainActions';
import { bindActionCreators } from 'redux';
import { ToastContainer } from 'react-toastify';
import ReportsBi from '../components/ReportsBi';
import DashboardContainer from '../components/Dashboard/DashboardContainer';
import SurveyResultsContainer from '../components/SurveyResults/SurveyResultsContainer';
import SatisfationResultsContainer from '../components/SatisfactionResults/SatisfationResultsContainer';
import Surveys from '../components/Surveys/Surveys';
import Satisfations from '../components/Satisfations/Satisfations';

export const bHistory = createHistory();

const sections = [{
    id: 1,
    route: "/dashboard",
    name: "Resumen de visitas"
}, {
    id: 2,
    route: "/surveys-results",
    name: "Resultados de enquisas por orixe"
}, {
    id: 3,
    route: "/satisfactions-results",
    name: "Resultados satisfacción"
}, {
    id: 4,
    route: "/surveys",
    name: "Enquisas"
}, {
    id: 5,
    route: "/satisfactions",
    name: "Satisfacción"
},
{
    id: 6,
    route: "/reportsbi",
    name: "Informes avanzados"
}
];

class AppRouter extends Component {

    constructor(props) {
        // Prevent warning to use getDerivedStateFromProps
        super(props);
        this.state = {};
    }

    componentDidMount() {
        let sessionData = JSON.parse(sessionStorage.getItem('session'));
        this.props.actions.setSessionData(sessionData);
        if (sessionData) {
            this.props.actions.getConsultTypes(sessionData.userName, sessionData.passwd);
            this.props.actions.requestCountries(sessionData.userName, sessionData.passwd);
            this.props.actions.getProvinces(sessionData.userName, sessionData.passwd);
            this.props.actions.getMunicipalities(sessionData.userName, sessionData.passwd);
            this.props.actions.getComunities(sessionData.userName, sessionData.passwd);
            this.props.actions.getOffices(sessionData.userName, sessionData.passwd);
            this.props.actions.requestLanguages(sessionData.userName, sessionData.passwd);
        }
    }

    checkSession = () => {
        let sessionData = JSON.parse(sessionStorage.getItem('session'));
        this.props.actions.setSessionData(sessionData);
        this.props.actions.getConsultTypes(sessionData.userName, sessionData.passwd);
        this.props.actions.requestCountries(sessionData.userName, sessionData.passwd);
        this.props.actions.getProvinces(sessionData.userName, sessionData.passwd);
        this.props.actions.getMunicipalities(sessionData.userName, sessionData.passwd);
        this.props.actions.getComunities(sessionData.userName, sessionData.passwd);
        this.props.actions.getOffices(sessionData.userName, sessionData.passwd);
        this.props.actions.requestLanguages(sessionData.userName, sessionData.passwd);
    }

    render() {
        const { classes } = this.props;
        const { navLink } = customStyles;
        let loading = false;

        const { sessionData, provinces, languages, municipalities, offices, consultTypes, comunities } = this.props.main;
        if (!provinces || !languages || !municipalities || !offices || !consultTypes || !comunities) {
            loading = true;
        }

        return (
            <Router history={bHistory}>
                <Fragment>
                    <ToastContainer hideProgressBar={true} closeButton={false} />
                    {sessionData ?
                        <div className={classes.rootContainer}>
                            <AppNavbar title="Arousanorte" />
                            <Drawer variant="permanent" classes={{ paper: classes.drawerPaper }} className="menuBar">
                                <div className={classes.toolbar} />
                                <List style={{ maxWidth: '220px' }}>
                                    {sections.map((section) => {
                                        return (
                                            <NavLink key={`link_${section.id}`} to={section.route} style={navLink} activeClassName="selected">
                                                <ListItem button key={`section_${section.id}`}>
                                                    <ListItemText primary={section.name} />
                                                </ListItem>
                                            </NavLink>
                                        );
                                    })}
                                </List>
                            </Drawer>
                            <div style={{ marginTop: '3em', width: '100%', height: 'calc(100vh - 3em)', overflow: 'hidden', overflowY: 'auto', backgroundColor: '#fafafa' }}>
                                <main style={{ padding: '0.5em' }}>
                                    {/* <div className={classes.toolbar} /> */}
                                    {loading ?
                                        <Card style={{ maxWidth: '1200px', margin: '0 auto' }}>
                                            <Typography variant="headline" component="h4">Cargando...{" "}</Typography>
                                            <LinearProgress />
                                        </Card>
                                        :
                                        <Grid id="content" style={{ margin: '0 auto' }} container justify='center'>
                                            <Switch>
                                                <Route exact path="/dashboard" component={DashboardContainer} />
                                                <Route exact path="/surveys-results" component={SurveyResultsContainer} />
                                                <Route exact path="/satisfactions-results" component={SatisfationResultsContainer} />
                                                <Route exact path="/surveys" component={Surveys} />
                                                <Route exact path="/satisfactions" component={Satisfations} />
                                                <Route exact path="/satisfactions/:id?" component={EnquisaSatisfaccionContainer} />
                                                <Route exact path="/reportsbi" component={ReportsBi} />
                                                <Route path="*" component={() => { return (<Redirect to="/dashboard" />) }} />
                                            </Switch>
                                        </Grid>
                                    }

                                </main>
                            </div>
                        </div>
                        :
                        <Switch>
                            <Route path="*" component={() => { return (<Login onLogin={this.checkSession} />) }} />
                        </Switch>
                    }
                </Fragment>
            </Router>
        );
    }
}

const styles = theme => ({
    rootContainer: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex'
    },
    drawerPaper: {
        position: 'relative',
        width: '15rem'
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3,
        minWidth: 0
    },
    toolbar: theme.mixins.toolbar,
    link: {
        textDecoration: 'none'
    }
});

const customStyles = {
    navLink: {
        textDecoration: "none",
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AppRouter));



// WEBPACK FOOTER //
// ./src/containers/AppRouter.js